import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';

import { parseHttpErrorBody } from '../../shared/forms/parse-http-error-body';
import {RequestParameters} from '../../shared/models/request-parameters/parameter.model';
import {GlobalVariable} from '../../global';
import {UserCollect} from './user-collector.model';
import {Observable} from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { UserCollectAgency } from './show-user-collector/user-collector-agencies/user-collector-agency.model';

import { UserCollectProduct } from './show-user-collector/user-collector-products/user-collector-product.model';
import { UserCollectBank } from './show-user-collector/user-collect-banks/user-collect-bank.model';
import { CollectSubUser } from './show-user-collector/collect-sub-user/collect-sub-user.model';
import {
  CollectOperationCost
} from './show-user-collector/collect-operation-costs/collect-operation-cost.model';

@Injectable()
export class UsersCollectorService {
  imageToShow: any;
  private subject = new Subject<any>();
  public updateFreezesData = new Subject<any>();

  constructor(private http: HttpClient) {
  }
  getQRCodeBase64Text(url){
    return this.http.get(url);
  }
  getFreezes(reference, parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/freezes/account/'+reference, {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }


  getUnfreezes(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/unfreezes', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }
  showCollectAgencyQRCode(reference:string){
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/agency/' + reference +"/qr-code", {
    responseType: 'blob'})
      .map(
        (response: any) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }
  getCollectSubUserPermissions(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/permissions', {
      params: parameters.getHttpParams(),
    }).map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  getUsersCollector (parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/users', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  getCollectSubUser(reference: string) {

    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/sub-user/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  getUserCollect (reference: string) {

    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/user/' + reference, {
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  resetUserCollectPin(userCollect: UserCollect) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL +
       '/user/' + userCollect.phone + '/reset-pin')
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  getUserCollectAgencies(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/agencies', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  getUserCollectSubUsers(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/sub-users', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  getCollectOperationCosts(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/operation-costs', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  getUserCollectBanks(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/banks', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  getUserCollectProducts(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/products', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  postUserCollect (UserCollect: UserCollect) {

    const body = this.normalizeUserCollectData(UserCollect);

    return this.http.post(GlobalVariable.BASE_COLLECT_API_URL + '/users', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  patchUserCollect (userCollect: UserCollect) {

    const body = this.normalizeUserCollectData(userCollect);

    return this.http.patch(GlobalVariable.BASE_COLLECT_API_URL + '/user/' + userCollect.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  postCollectSubUser( collectSubUser: CollectSubUser ) {

    const body = this.normalizeCollectSubUserData(collectSubUser);

    return this.http.post(GlobalVariable.BASE_COLLECT_API_URL + '/sub-users', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  getActivateCollectSubUser( collectSubUser: CollectSubUser ) {

    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/sub-user/'
    + collectSubUser.phone +'/activate')
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  getDeactivateCollectSubUser( collectSubUser: CollectSubUser ) {

    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/sub-user/'
    + collectSubUser.phone +'/deactivate')
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  resetCollectSubUserSecretCode( collectSubUser: CollectSubUser ) {

    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/sub-user/'
    + collectSubUser.phone +'/reset-pin')
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  postCollectOperationCost(collectOperationCost: CollectOperationCost ) {

    const body = this.normalizeCollectOperationCostData(collectOperationCost);

    return this.http.post(GlobalVariable.BASE_COLLECT_API_URL + '/operation-costs', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  postUserCollectBank(userCollectBank: UserCollectBank ) {

    const body = this.normalizeUserCollectBankData(userCollectBank);

    return this.http.post(GlobalVariable.BASE_COLLECT_API_URL + '/banks', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  postUserCollectAgency (userCollectAgency: UserCollectAgency ) {

    const body = this.normalizeUserCollectAgencyData(userCollectAgency);

    return this.http.post(GlobalVariable.BASE_COLLECT_API_URL + '/agencies', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  patchCollectSubUser( collectSubUser: CollectSubUser ) {

    const body = this.normalizeCollectSubUserData(collectSubUser);

    return this.http.patch(GlobalVariable.BASE_COLLECT_API_URL + '/sub-user/' + collectSubUser.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  deleteCollectOperationCost(collectOperationCost: CollectOperationCost) {

    return this.http.delete(GlobalVariable.BASE_COLLECT_API_URL + '/operation-cost/' 
    + collectOperationCost.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  putCollectOperationCost(collectOperationCost: CollectOperationCost) {

    const body = this.normalizeCollectOperationCostData(collectOperationCost);

    return this.http.patch(GlobalVariable.BASE_COLLECT_API_URL + '/operation-cost/' 
    + collectOperationCost.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  putUserCollectBank(userCollectBank: UserCollectBank) {

    const body = this.normalizeUserCollectBankData(userCollectBank);

    return this.http.put(GlobalVariable.BASE_COLLECT_API_URL + '/bank/' 
    + userCollectBank.reference , body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  patchUserCollectAgency (userCollectAgency: UserCollectAgency ) {

    const body = this.normalizeUserCollectAgencyData(userCollectAgency);

    return this.http.patch(GlobalVariable.BASE_COLLECT_API_URL + '/agency/' + userCollectAgency.reference , body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  postUserCollectProduct(UserCollectProduct: UserCollectProduct ) {

    const body = this.normalizeUserCollectProductData(UserCollectProduct);

    return this.http.post(GlobalVariable.BASE_COLLECT_API_URL + '/products', body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  patchUserCollectProduct(userCollectProduct: UserCollectProduct ) {

    const body = this.normalizeUserCollectProductData(userCollectProduct);

    return this.http.patch(GlobalVariable.BASE_COLLECT_API_URL + '/product/' + userCollectProduct.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  putUserCollect (UserCollect: UserCollect) {

    const body = this.normalizeUserCollectData(UserCollect);

    return this.http.put(GlobalVariable.BASE_API_URL + '/operator/clk/' + UserCollect.reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );

  }

  deleteUserCollect (UserCollect: UserCollect) {
    return this.http.delete(GlobalVariable.BASE_API_URL + '/operator/clk/' + UserCollect.reference)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }
  
  blockUnblockUserCollect(userCollect: UserCollect, stateToApply) {
    return this.http.put(GlobalVariable.BASE_API_URL + '/account/' + userCollect.phone + '/' + stateToApply, {})
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch((error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  disableUserCollectProduct(userCollectProduct: UserCollectProduct, stateToApply) {
    console.log(stateToApply);
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/product/' + userCollectProduct.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch((error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  disableUserCollectAgency(userCollectAgency: UserCollectAgency, stateToApply) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/agency/' + userCollectAgency.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch((error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }
  defineDefaultCollectProduct(userCollectProduct:UserCollectProduct){
    return this.http.put(GlobalVariable.BASE_COLLECT_API_URL + '/product/'+ userCollectProduct.reference+'/defaultProduct',{})
    .map(
      (response: HttpResponse<any>) => {
        return response ;
      }
    ).catch((error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status,
          body: parseHttpErrorBody(error)
        });
      }
    );
  }
  defineDefaultCollectAgency(userCollectAgency: UserCollectAgency){
    return this.http.put(GlobalVariable.BASE_COLLECT_API_URL + '/agency/'+ userCollectAgency.reference+'/defaultAgency',{})
    .map(
      (response: HttpResponse<any>) => {
        return response ;
      }
    ).catch((error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status,
          body: parseHttpErrorBody(error)
        });
      }
    );
  }

  disableUserCollectBank(userCollectBank: UserCollectBank, stateToApply) {
    return this.http.get(GlobalVariable.BASE_COLLECT_API_URL + '/bank/' + userCollectBank.reference + '/' + stateToApply)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch((error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  private normalizeUserCollectProductData(userCollectProduct: UserCollectProduct ): UserCollectProduct {
    const body = Object.assign({}, userCollectProduct);
    delete body.reference;
    return body;
  }

  private normalizeCollectSubUserData( collectSubUser: CollectSubUser ): CollectSubUser {
    const body = Object.assign({}, collectSubUser);
    delete body.reference;
    let permissions = [];
    if (body.permissions.length > 0) {
      permissions = body.permissions.map(
        (permission) => {
          return permission.reference;
        }
      );
    }
    body.permissions = permissions;
    return body;
  }

  private normalizeCollectOperationCostData(collectOperationCost:
     CollectOperationCost): CollectOperationCost {
    const body = Object.assign({}, collectOperationCost);
    delete body.reference;
    delete body.billingType;
    return body;
  }

  private normalizeUserCollectBankData(userCollectBank: UserCollectBank): UserCollectBank {
    const body = Object.assign({}, userCollectBank);
    delete body.reference;
    return body;
  }

  private normalizeUserCollectAgencyData(userCollectAgency: UserCollectAgency ): UserCollectAgency {
    const body = Object.assign({}, userCollectAgency);
    delete body.reference;
    return body;
  }

  private normalizeUserCollectData(userCollect: UserCollect): UserCollect {

    const body = Object.assign({}, userCollect);
    delete body.reference;

    if (body.picture !== null) {
      body.picture = body.picture.reference;
    }
    // if (body.country !== null) {
    //   body.country = body.country.reference;
    // }
    // if (body.city !== null) {
    //   body.city = body.city.reference;
    // }
    // if (body.callCenter !== null) {
    //   body.callCenter = body.callCenter.reference;
    // }
    // if (body.role !== null) {
    //   body.role = body.role.reference;
    // }
    // if (body.platform !== null) {
    //   body.platform = body.platform.reference;
    // }
    return body;
  }

  emitMessage(msg: object) {
    this.subject.next(msg);
  }
  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  postFreeze(body) {
    const operation = body.operation;

    delete body.reference;
    delete body.unfreezingComment;
    delete body.action;
    delete body.operation;
    delete body.prefixedSentAmount;
    delete body.prefixedReceivedAmount;


    return this.http.post(GlobalVariable.BASE_API_URL + '/freeze/' + operation, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            message: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

  postUnfreeze(body) {
    const reference = body.reference;
    delete body.reference;
    delete body.freezingComment;
    delete body.operation;
    delete body.prefixedSentAmount;
    delete body.prefixedReceivedAmount;
    
    return this.http.post(GlobalVariable.BASE_API_URL + '/unfreeze/' +
     reference, body)
      .map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            message: JSON.parse(error.error).message,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/users/users-collector/users-collector.service.ts